import {MyopBindMessage, MyopBindReplayMessage} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";
import {IComponentConfig, IRefConfig} from "../common";
import {loaderOptions} from "../host/hostSDK.ts";

const ReplayMessageKey = 'RefComponentCreatedMessage'

export class CreateRefComponentMessage extends MyopBindMessage<void, RefComponentCreatedMessage> {
    replyMessageKey: MyopMessageKey = ReplayMessageKey
    messageType = 'CreateRefComponentMessage';

    constructor(public refConfig: IRefConfig,
                public nestedComponentConfig: IComponentConfig,
                public options: loaderOptions,
                handler: (message: RefComponentCreatedMessage) => void,
    ) {
        super(handler);

    }
}

export type NestedRef = {
    refName: string,
    componentDefinitionId: string
}

export class RefComponentCreatedMessage extends MyopBindReplayMessage {
    messageType = ReplayMessageKey

    constructor(public replayToHandler: string, public nestedRefs: NestedRef[], public failed?: boolean) {
        super(replayToHandler);
    }
}
